// TanStack Query keys shared across screens, so "something changed the balance" can refresh every
// view of it at once. Keys are prefixes: invalidating `dashboard(id)` refetches all of that
// workspace's dashboard queries.
export const queryKeys = {
  workspace: (workspaceId: string) => ['workspace', workspaceId] as const,
  dashboard: (workspaceId: string) => ['dashboard', workspaceId] as const,
};
